import { getEmployeeFiltersServices } from '@api/employees';
import { getEmployeeFiltersProfiles } from '@api/employees';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

export const useEmployeeFilters = () => {
  const { t } = useTranslation();
  const { data: profiles, isFetching: isProfilesLoading } = useQuery({
    queryKey: ['employee-table-filters-profiles'],
    queryFn: getEmployeeFiltersProfiles,
  });

  const { data: services, isLoading: isServicesLoading } = useQuery({
    queryKey: ['employee-table-filters-services'],
    queryFn: getEmployeeFiltersServices,
  });

  return {
    filtersOptions: {
      profiles:
        profiles?.map((value) => ({ label: value.name, value: value.id, color: value.color })) ||
        [],
      services: services?.map((value) => ({ label: t(`SERVICE_TYPE.${value}`), value })) || [],
    },
    isLoading: isProfilesLoading || isServicesLoading,
  };
};
